import { Box, ColorOptions, IconButton, Text, TextTypesOptions } from '@jfs/ui-new'
import * as React from 'react'
import { FC, ReactElement, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { Dimensions } from 'react-native'
import { ModBox } from '../ModifiedBox/ModifiedBox'
import { Separator } from '../Separator'
import { styles } from './styles'
import {
  subTitleColorMap,
  subTitleTypes,
  titleColorMap,
  TitleSubtitleLayoutColorTheme,
  TitleSubtitleLayoutProps,
  TitleSubtitleLayoutTypes,
  titleTypes
} from './types'

const screenWidthMarginBuffer = 200
const topBuffer = 30

const renderPortal = (tooltip: string, isHovering: boolean, hideIcon: boolean, layout: any): React.ReactPortal => {
  return ReactDOM.createPortal(renderHoverView(tooltip, isHovering, hideIcon, layout), document.body)
}

const renderHoverView = (data: string, isHovering: boolean, hideIcon: boolean, layout: any): ReactElement => {
  const show = isHovering && !hideIcon
  const width = Dimensions.get('window').width
  const leftPadding =
    width - layout?.left > screenWidthMarginBuffer ? layout?.left : layout?.left - screenWidthMarginBuffer
  return (
    <ModBox
      testID="tooltip-view"
      {...styles.toolTipContainer}
      top={layout?.top + topBuffer}
      left={leftPadding}
      show={show}>
      <Box m={8}>
        <Text color={'LIGHT_BLACK'} type={'body2'} fontWeight="MEDIUM">
          {data}
        </Text>
      </Box>
    </ModBox>
  )
}

const TitleSubtitleLayout: FC<TitleSubtitleLayoutProps> = ({
  type,
  color,
  placeHolder,
  title = '',
  setFieldValue,
  fieldName,
  hideIcon = true,
  onIconPress,
  tooltip = '',
}: TitleSubtitleLayoutProps) => {
  const [isHovering, setIsHovering] = useState(false)
  const [layout, onLayout] = useState({})

  useEffect(() => {
    if (setFieldValue && fieldName) {
      setFieldValue(fieldName, title)
    }
  }, [setFieldValue, fieldName, title])

  const onPress = () => {
    onIconPress
  }

  const handleHover = (hovering: boolean): void => {
    setIsHovering(hovering)
  }
  return (
    <Box {...styles[type].container} key={placeHolder + title} testID={`${title.replaceAll(' ', '')}`}>
      <Box justify="center">
        <Text
          fontFamily="jiotype-bold"
          type={titleTypes[type] as TextTypesOptions}
          color={titleColorMap()[color] as ColorOptions}>
          {String(placeHolder)}
        </Text>
      </Box>
      <Box {...styles[type].subTitleContainer}>
        <Text
          fontFamily="jiotype-MEDIUM"
          type={subTitleTypes[type] as TextTypesOptions}
          color={subTitleColorMap()[color] as ColorOptions}>
          {title}
        </Text>
        <Separator width={10} hide={hideIcon} />
        <ModBox
          onLayout={({ nativeEvent }) => {
            onLayout(nativeEvent?.layout)
          }}
          onPress={() => null}
          onHover={handleHover}
          show={!hideIcon}>
          <IconButton id={'FAQ'} testID="faq-icon" onPress={onPress} color={'LIGHT_BLACK'} />
        </ModBox>
      </Box>
      {renderPortal(tooltip, isHovering, hideIcon, layout)}
    </Box>
  )
}

export { TitleSubtitleLayoutTypes, TitleSubtitleLayoutColorTheme, TitleSubtitleLayout }
